var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled, { css } from 'styled-components';
import Skeleton from '../../Progress/Skeleton/Skeleton';
const CardStyle = styled.div `
  font-family: ${props => props.theme.fonts.fontFamily};
  line-height: ${props => props.theme.fonts.lineHeight};
  position: relative;
  display: ${props => props.display};
  width: ${props => props.width};
  height: ${props => props.height};
  transition: all 300ms ease-in-out;
  box-sizing: border-box;
  background-color: ${props => props.theme.utils.getColor(props.backgroundColor)};
  ${props => props.mediaQuery};
  ${props => !props.isContent &&
    css `
      box-shadow: ${props.theme.boxes.boxShadow};
      border-radius: ${props.theme.borders.borderRadius};
      padding: ${props => props.padding};
      margin: ${props => props.margin};
    `} ${props => props.noBorder &&
    css `
        box-shadow: 0px 0px 0px 0px;
        border: none;
        border-radius: 0px 0px 0px 0px;
        padding: ${props => props.padding};
        margin: ${props => props.margin};
      `} ${props => props.transition &&
    css `
    cursor: pointer;
  &:hover {
    box-shadow: ${props.theme.boxes.boxShadowTransition}
    `};
`;
const Card = (_a) => {
    var { backgroundColor = '#fff', display = 'inline-block', padding = '1.8rem 1.8rem 1.8rem 1.8rem', margin = '0.4rem 0.4rem 0.4rem 0.4rem', width = 'auto', height = 'auto', transition = false, isContent = false, noBorder = false, children, skeleton, isLoading, mediaQuery } = _a, props = __rest(_a, ["backgroundColor", "display", "padding", "margin", "width", "height", "transition", "isContent", "noBorder", "children", "skeleton", "isLoading", "mediaQuery"]);
    return (isLoading
        ? _jsx(Skeleton, Object.assign({ height: height, width: width, display: display, style: { margin, padding } }, skeleton))
        : _jsx(CardStyle, Object.assign({ mediaQuery: mediaQuery, backgroundColor: backgroundColor, display: display, transition: transition, padding: padding, margin: margin, isContent: isContent, noBorder: noBorder, width: width, height: height }, props, { children: children })));
};
export default Card;
